import { queryOptions, useQuery } from '@tanstack/react-query';
import type { GrantLatestByType } from '@zoxo/shared';

import { api } from '../../lib/api';

/**
 * 유형별 최신 — 첫 화면의 네 칸.
 *
 * 랜딩 loader 가 같은 `latestByTypeQuery` 로 캐시를 채우고, 서버 캐시가 브라우저로 넘어간다.
 *
 * **실패해도 화면을 안 막는다.** 목록이 본체고 이건 덤이라, `useSuspenseQuery`
 * 가 아니라 `useQuery` 다 — 이것 때문에 목록까지 못 보게 할 이유가 없다.
 */
export const latestByTypeQuery = queryOptions({
  queryKey: ['grants-latest'],
  queryFn: () => api.get<GrantLatestByType>('/grants/latest'),
  // 목록보다 덜 자주 바뀐다. 매 진입마다 다시 받을 이유가 없다.
  staleTime: 5 * 60 * 1000,
});

export function useLatestByType() {
  return useQuery(latestByTypeQuery);
}
